import { Box, type BoxProps } from '@mantine/core'

export function Items({
  children,
  ...props
}: React.PropsWithChildren<BoxProps>) {
  return <Box {...props}>{children}</Box>
}

// Components

export * from './components/GridItemPhotosManager/GridItemPhotosManager'
export * from './components/OvertimeCharge/OvertimeCharge'
export * from './components/TextItemPrice/TextItemPrice'
export * from './components/TableItems/TableItems'
export * from './components/TableItemPricingRules/TableItemPricingRules'

// Hooks
export * from './hooks/useItemPhotoUrl'
export * from './hooks/useItemLowestPriceRule'

// Pages
export * from './pages/PageItemsList'
